module.exports = __webpack_public_path__ + "img/heating.a56defac.png";